import moment from "moment";


/**
 *
 * @param date
 * @param interval
 * @returns {string}
 */
export function makeNewFromInterval(date, interval) {

    let temporalValue = 0;
    let temporalType = 'days';

    switch (interval) {
        case 1:
            temporalValue = 1;
            temporalType = 'month';
            break;
        case 2:
            temporalValue = 3;
            temporalType = 'month';
            break;
        case 3:
            temporalValue = 6;
            temporalType = 'month';
            break;
        case 4:
            temporalValue = 1;
            temporalType = 'year';
            break;
    }

    return moment(date).add(temporalValue, temporalType).format('YYYY-MM-DD');

}



// WEBPACK FOOTER //
// ./resources/assets/js/fn/datehelper.js